/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Editor from "@monaco-editor/react";
import AceEditor from "react-ace";
import { returnErrors } from "../Redux/ActionCreators/errorAction";
import { getCodingQuestionByID, resetCodingQuestionById, runCodingQuestion } from "../Redux/ActionCreators/testLibraryAction";
import './CodeEditor/editor.scss'

import "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-sql";
import ace from "ace-builds/src-noconflict/ace";
import { MenuItem, Select } from "@mui/material";
import { ThreeDots } from "../Loader/loader";

ace.config.set("basePath", "/node_modules/ace-builds/src-noconflict");

const TryCodingRunner = () => {
  const dispatch = useDispatch();
  const { questionId } = useParams();
  const aceRef = useRef(null);

  const { codingQuestionByIdResponse } = useSelector(
    (state) => state.testLibrary
  );

  const question = codingQuestionByIdResponse?.question;

  const [code, setCode] = useState("");
  const [language, setLanguage] = useState(null);
  const [processing, setProcessing] = useState(false);

  const [output, setOutput] = useState("");
  const [outputStatus, setOutputStatus] = useState(null);
  const [compileTestCases, setCompileTestCases] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [compile, setCompile] = useState(false);
  const [compail, setCompail] = useState(false);
  const [runInput, setRunInput] = useState("");
  const [active, setActive] = useState("");
  const [showCompileWindow, setShowCompileWindow] = useState(false);
  const [isCompiling, setIsCompiling] = useState(false);

  const isLoading = !question;

  const visibleTestCases = compileTestCases.filter(tc => tc.hidden === false);
  const firstVisible = visibleTestCases[0];
  const passCount = visibleTestCases.filter(tc => tc.executionStatus === 1).length;
  const totalCount = visibleTestCases.length;

  const allPassed = totalCount > 0 && passCount === totalCount;

  useEffect(() => {
    if (!questionId) return;

    dispatch(resetCodingQuestionById());
    dispatch(getCodingQuestionByID(questionId));
  }, [questionId]);


  const parsedData = useMemo(() => {
    if (!question?.data) return null;
    try {
      return JSON.parse(question.data);
    } catch {
      return null;
    }
  }, [question]);


  const languageOptions = useMemo(() => {
    if (!question) return [];
    return question.languages.map((l) => ({
      label: l.displayLanguage,
      value: l.codingLanguage,
    }));
  }, [question]);

  useEffect(() => {
    if (!language && languageOptions.length > 0) {
      setLanguage(languageOptions[0]);
    }
  }, [languageOptions]);


  const starterCode = useMemo(() => {
    if (!question) return "";

    // v1 → blank
    if (question.version === 1) return "";

    // v2 → stub
    if (question.version === 2 && parsedData?.stubs?.length > 0) {
      const { head = "", body = "", tail = "" } = parsedData.stubs[0];
      const normalize = (s = "") => s.replace(/\r\n/g, "\n");
      return normalize(head) + normalize(body) + normalize(tail);
    }

    return "";
  }, [question, parsedData]);

  useEffect(() => {
    setCode(starterCode);
  }, [starterCode]);


  const aceMode = useMemo(() => {
    if (language?.value === "python") return "python";
    if (language?.value === "sql") return "sql";
    return "javascript";
  }, [language]);


  const handleRun = async () => {
    if (!language?.value) {
      returnErrors(dispatch, "Please select language", 500);
      return;
    }

    setProcessing(true);
    setCompile(true);
    setCompail(true);
    setActive("run");
    setRunInput("");
    setOutput("");
    setCompileTestCases([]);
    setOutputStatus(null);

    const payload = {
      questionId: question.id,
      sourceCode: code,
      language: language.value,
      input: runInput || "",
    };

    try {
      const res = await dispatch(runCodingQuestion(payload));

      if (res?.type === "RUN_CODING_QUESTION") {
        const oc = res.payload?.ocResponse || {};
        const testCases = res.payload?.testCases || [];

        setOutputStatus({
          ...oc,
          stdout: oc.stdout ?? oc.actualOutput ?? "",
          actualOutput: oc.actualOutput ?? null,
          input: oc.input ?? null,
          useInput: oc.useInput ?? false,
          executionStatus: oc.executionStatus ?? 0,
          executionTime: oc.executionTime ?? null,
        });

        setCompileTestCases(testCases);
        setRunInput(oc.input || "");
        setOutput(oc.stdout || "");
      }
    } finally {
      setCompail(false);
      setProcessing(false);
    }
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{width:'100vw', height:'100vh'}}>
        <div className="loading-overlay" style={{alignItems:'start', color:'#F75891', height:'auto'}}>
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading job summary...</span>
          </div>
        </div>
      </div>
    );
  }

  if (question.questionTypeID === 13) return <div>Notebook questions not supported</div>;

  return (
    <div className="d-flex align-items-center justify-content-center"style={{margin:'auto', minHeight:'100vh', maxWidth:'100vw', overflowX:'hidden'}}>
      <div className="coding-container" style={{width:'100%'}}>
        <div className="d-flex" style={{ border: "1px solid #D7DADB" }}>
            <Fragment>
              <div
                className="col-md-5"
                style={{
                  padding: 15,
                  borderRight: "2px solid #D7DADB",
                  maxHeight: "73vh",
                  overflowY: "auto",
                }}
              >
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <div className="d-flex align-items-center">
                    <p style={{ marginLeft: 8, fontSize: 18, color: "#555" }}>
                      {question.version === 1 ?  "Database" : "Coding"}
                    </p>
                  </div>
                </div>
                <h2>{question.name}</h2>
              <div dangerouslySetInnerHTML={{ __html: question.description }} />
              </div>
              <div className="col-md-7">
                {!submit && (
                  <Fragment>
                    <div className="lang-dd">
                      <div
                        className="d-flex align-items-center"
                        style={{ width: "40%" }}
                      >
                        <label className="col-form-label">Language</label>
                        &nbsp;&nbsp;
                        <div style={{ width: "70%" }}>
                          <Select
                            fullWidth
                            value={language?.value || ""}
                            onChange={(e) => {
                              const selected = languageOptions.find(
                                (l) => l.value === e.target.value
                              );
                              setLanguage(selected || null);
                            }}
                          >
                            {languageOptions.map((l) => (
                              <MenuItem key={l.value} value={l.value}>
                                {l.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </div>
                    <div style={{ borderBottom: "2px solid #D7DADB" }}></div>
                    <div className="mt-2">
                      {question.version === 2 ? (
                      <AceEditor
                        mode={aceMode}
                        theme="github"
                        value={code}
                        // defaultValue={`${head}${editableBody}${tail}`}
                        width="100%"
                        height="60vh"
                        fontSize={14}
                        readOnly={false}
                        // onLoad={onAceLoad}
                        onChange={setCode}
                        setOptions={{
                          useWorker: false,
                          showPrintMargin: false,
                          showLineNumbers: true,
                          tabSize: 2,
                        }}
                        style={{
                          opacity: 1
                        }}
                        ref={aceRef}
                      />
                    ) : (
                      <Editor
                        height="60vh"
                        width={`100%`}
                        language={language?.value || "javascript"}
                        value={code}
                        theme="vs-light"
                        // defaultValue="// some comment"
                        onChange={(v) => setCode(v || "")}
                        options={{
                          autoIndent: "full",
                          contextmenu: true,
                          fontFamily: "monospace",
                          lineHeight: 24,
                          hideCursorInOverviewRuler: true,
                          inlineSuggest: true,
                          fontSize: "14px",
                          formatOnType: true,
                          autoClosingBrackets: true,
                          minimap: { enabled: false },
                          scrollbar: {
                            horizontalSliderSize: 4,
                            verticalSliderSize: 18,
                          },
                          selectOnLineNumbers: true,
                          roundedSelection: false,
                          cursorStyle: "line",
                          automaticLayout: true,
                        }}
                      />
                    )}

                      <div className="run-code-view">
                        <div className="run-header">
                          <button
                            className="cursor-pointer submit-btn"
                            disabled={processing}
                            onClick={handleRun}
                            style={{background: (processing) ? '#D3D3D3' : '', cursor: (processing) ? "not-allowed" : "pointer",}}
                          >
                            COMPILE AND RUN CODE
                          </button>
                        </div>
                        {compile ? (
                        <div className="complie-window" style={{ minHeight: "200px",}}>
                          {compail && (
                            <div
                              style={{
                                padding: 20,
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                fontSize: 18,
                                color: "#555",
                              }}
                            >
                              <ThreeDots color="#009199" />
                              <span>Compiling and running your code…</span>
                            </div>
                          )}
                          {active === "run" && outputStatus && (
                            <div>
                              <h4 style={{ marginBottom: 10 }}>Compile Result</h4>

                              {outputStatus.useInput && runInput && (
                                <div
                                  style={{
                                    marginBottom: 12,
                                    padding: 10,
                                    borderRadius: 6,
                                    background:
                                      outputStatus.executionStatus === 1
                                        ? "#E6FFE6"
                                        : "#FFE6E6",
                                    border:
                                      outputStatus.executionStatus === 1
                                        ? "1px solid #2E8B57"
                                        : "1px solid #B22222",
                                    fontFamily: "monospace",
                                    whiteSpace: "pre-wrap",
                                    maxHeight:'200px',
                                    maxWidth: "100%",
                                    overflow: "auto",
                                  }}
                                >
                                  <strong>Input</strong>
                                  <pre style={{ margin: "6px 0 0 0" }}>{runInput}</pre>
                                </div>
                              )}

                              <div
                                style={{
                                  marginBottom: 12,
                                  padding: 10,
                                  borderRadius: 6,
                                  background:
                                    outputStatus.executionStatus === 1
                                      ? "#E6FFE6"
                                      : "#FFE6E6",
                                  border:
                                    outputStatus.executionStatus === 1
                                      ? "1px solid #2E8B57"
                                      : "1px solid #B22222",
                                  fontFamily: "monospace",
                                  whiteSpace: "pre-wrap",
                                  maxHeight:'200px',
                                  maxWidth: "100%",
                                  overflow: "auto",
                                }}
                              >
                                <strong>Output</strong>
                                <pre style={{ margin: "6px 0 0 0", whiteSpace: "pre", minWidth: "max-content" }}>
                                  {outputStatus.stdout || outputStatus.actualOutput || "—"}
                                </pre>
                              </div>

                              <div
                                style={{
                                  fontWeight: "bold",
                                  color:
                                    outputStatus.executionStatus === 1 ? "green" : "red",
                                }}
                              >
                                Status:{" "}
                                {outputStatus.executionStatus === 1
                                  ? "Success"
                                  : "Failed"}
                              </div>
                            </div>
                          )}

                          <div style={{ fontFamily: "monospace", marginTop: 10 }}>

                          {/* Summary line */}
                          {compileTestCases.length > 0 && (
                            <div
                              style={{
                                color: allPassed ? "#1B8E3E" : "#B00020",
                                fontWeight: 600,
                                fontSize: 16,
                                marginBottom: 12
                              }}
                            >
                              {allPassed
                                ? `✓ All sample testcases passed! (${passCount}/${totalCount})`
                                : `✗ Some sample testcases failed! (${passCount}/${totalCount})`}
                            </div>
                          )}

                          {/* Each testcase status */}
                          {compileTestCases.map((tc) => (
                            <div key={tc.testCaseId} style={{ marginBottom: 6 }}>
                              <strong>Testcase {tc.testCaseId} :</strong>{" "}
                              <span style={{ color: tc.executionStatus === 1 ? "#1B8E3E" : "#B00020" }}>
                                {tc.executionStatus === 1 ? "Passed" : "Failed"}
                              </span>
                            </div>
                          ))}

                          {/* Details only for visible testcase */}
                          {firstVisible && (
                            <>
                              <div style={{ marginTop: 14 }}>
                                <div style={{ marginBottom: 6 }}>
                                  <strong style={{ color: firstVisible.executionStatus === 1 ? "#1B8E3E" : "#B00020" }}>Status</strong>{" "}
                                  <span style={{ color: firstVisible.executionStatus === 1 ? "#1B8E3E" : "#B00020" }}>
                                    {firstVisible.executionStatus === 1 ? "Passed" : "Failed"}
                                  </span>
                                </div>

                                <div style={{ marginBottom: 6 }}>
                                  <strong style={{ color: firstVisible.executionStatus === 1 ? "#1B8E3E" : "#B00020" }}>Execution time</strong>{" "}
                                  <span style={{ color: firstVisible.executionStatus === 1 ? "#1B8E3E" : "#B00020" }}>{outputStatus?.executionTime || "—"} ms</span>
                                </div>

                                <div style={{ marginBottom: 10 }}>
                                  <strong style={{ color: firstVisible.executionStatus === 1 ? "#1B8E3E" : "#B00020" }}>Description</strong>{" "}
                                  <span style={{ color: firstVisible.executionStatus === 1 ? "#1B8E3E" : "#B00020" }}>
                                    {firstVisible.executionStatus === 1
                                      ? "Testcase passed!"
                                      : "Output did not match expected result"}
                                  </span>
                                </div>

                                {firstVisible.input && (
                                  <div style={{ marginBottom: 10 }}>
                                    <strong style={{ color: firstVisible.executionStatus === 1 ? "#1B8E3E" : "#B00020" }}>Input</strong>
                                    <pre style={{ color: firstVisible.executionStatus === 1 ? "#1B8E3E" : "#B00020" }}>{firstVisible.input}</pre>
                                  </div>
                                )}

                                <div style={{ marginBottom: 6 }}>
                                  <strong style={{ color: firstVisible.executionStatus === 1 ? "#1B8E3E" : "#B00020" }}> Output</strong>
                                  <pre style={{ color: firstVisible.executionStatus === 1 ? "#1B8E3E" : "#B00020" }}>{firstVisible.actualOutput || "—"}</pre>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                        </div>
                      ) : null}
                      </div>
                    </div>
                  </Fragment>
                )} 
              </div>
            </Fragment>
        </div>
      </div>
    </div>
  );
};

export default TryCodingRunner;